import { isNode, isValidBusinessObject } from '@iotv/iotv-v3-types';
import { isEntityProgramme } from '@iotv/datamodel-core';
import { createContext } from 'react';
export const defaultEntityProgrammeSetReducerState = {
    programmeSetLoading: true,
    programmesLoading: true,
    programmeSet: null,
    programmes: null,
};
const isProgrammeSetReducerSetProgrammeSetLoadingAction = (x) => {
    const c = x;
    return !!c && c.type === 'SetProgrammeSetLoading' && typeof c.value.programmeSetLoading === 'boolean';
};
const isProgrammeSetReducerSetProgrammesLoadingAction = (x) => {
    const c = x;
    return !!c && c.type === 'SetProgrammesLoading' && typeof c.value.programmesLoading === 'boolean';
};
const isProgrammeSetReducerSetProgrammeSetAction = (x) => {
    const c = x;
    return !!c && c.type === 'SetProgrammeSet' && isValidBusinessObject(c.value.programmeSet);
};
const isProgrammeSetReducerSetProgrammeAction = (x) => {
    const c = x;
    return !!c && c.type === 'SetProgrammes' && c.value.programmes instanceof Array && c.value.programmes.every(isNode);
};
export const getEntityProgrammeSetReducer = () => (prev, action) => {
    const update = { ...prev };
    const relativeDate = new Date(); // repalce this with timerange in state
    if (isProgrammeSetReducerSetProgrammeSetLoadingAction(action)) {
        const { value: { programmeSetLoading }, } = action;
        update.programmeSetLoading = programmeSetLoading;
    }
    else if (isProgrammeSetReducerSetProgrammesLoadingAction(action)) {
        const { value: { programmesLoading }, } = action;
        update.programmesLoading = programmesLoading;
    }
    else if (isProgrammeSetReducerSetProgrammeSetAction(action)) {
        const { value: { programmeSet }, } = action;
        update.programmeSet = programmeSet;
        update.programmes = {};
    }
    else if (isProgrammeSetReducerSetProgrammeAction(action)) {
        const { value: { programmes }, } = action;
        if (!update.programmes)
            update.programmes = {};
        for (let programme of programmes) {
            const { sk } = programme;
            if (isEntityProgramme(programme)) {
                const enabledDateRanges = programme.timeslotsToDateRanges({ relativeDate });
                update.programmes[sk] = {
                    programme,
                    enabledDateRanges,
                };
            }
            else {
                console.log(`WARN: ${sk} is not an EntityProgramme `, programme);
            }
        }
    }
    else {
        console.log(`WARN: action fell through reducer`, action);
    }
    return update;
};
export const EntityProgrammeSetContext = createContext([
    defaultEntityProgrammeSetReducerState,
    (next) => {
        throw new Error('Reducer not initialized');
    },
]);
